export default "/assets/images/overreactor-circle.a434fc0d33f344ea.png";